import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import * as M from './mailingJobs.constants';
import { MailingJobDefinitionDto } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const r = new ReducerCreator<MailingJobDefinitionDto>()
    .register<MailingJobDefinitionDto[]>(M.MAILING_JOBS_LOAD, (M, payload) => {
        const newAE = new StoreItem<MailingJobDefinitionDto>();
        newAE.isLoading = true;
        return newAE;
    })
    .register<MailingJobDefinitionDto[]>(M.MAILING_JOBS_LOAD_SUCCESS, (M, payload) => {
        return buildStoreItem(payload);
    })
    .register<string>(APPLICATION_DISCONNECTED, (M, payload) => {
        const newHSC = new StoreItem<MailingJobDefinitionDto>();
        return newHSC;
    });

export function mailingJobsReducer(state: StoreItem<MailingJobDefinitionDto> = new StoreItem<MailingJobDefinitionDto>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
